module.exports = __webpack_public_path__ + "img/trackedNoticeSample.a3f09758.png";